<template>
	<div class="recruitment-center">
		<div class="recruitment-box">
			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in recruitmentTabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTab === index }]"
							@click="activeTab = index"
						>
							{{ item.name }}
						</div>
					</div>

					<!-- 右侧提示信息 -->
					<div class="tab-pane-info">
						<i class="el-icon-info"></i>
						<span>谢某某于13分钟前加入人才库</span>
						<span class="date">20250424</span>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<!-- 岗位内容区域--start -->
					<div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
						<!-- 搜索区域--start -->
						<div class="position-search-container">
							<!-- 搜索框区域 -->
							<div class="search-header">
								<div class="search-input-box">
									<el-select v-model="cityValue" placeholder="武汉" size="small" class="city-select">
										<el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
									<el-select v-model="certTypeValue" placeholder="PMC注册安全工程师" size="small" class="cert-type-select">
										<el-option
											v-for="item in certTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
									<el-input v-model="searchKeyword" placeholder="搜索证书号等" size="small" class="search-input"></el-input>
									<button class="cjt-button cjt-button--primary search-btn" type="button">高级查询</button>
								</div>
							</div>

							<div class="filter-container">
								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<el-select v-model="resourceTypeValue" placeholder="资质类型" size="small" class="filter-select">
										<el-option
											v-for="item in resourceTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</div>

								<a href="javascript:;" class="filter-empty">情况筛选条件</a>
							</div>
						</div>
						<!-- 搜索区域--end -->
						<div class="position-content">
							<!-- 左侧岗位列表 -->
							<div class="position-list">
								<div v-for="(item, index) in positionList" :key="index" class="position-item" @click="handleNavigationDeatil">
									<!-- 岗位信息区域 -->
									<div class="position-info">
										<div class="position-header">
											<h3 class="position-title">{{ item.title }}</h3>
											<div class="position-actions">
												<span v-if="item.isCollected" class="action-btn collect-btn is-collected">
													<svg-icon icon-class="collect"></svg-icon>
													已收藏
												</span>
												<span v-if="item.isDelivered" class="action-btn deliver-btn is-delivered">
													<svg-icon icon-class="deliver"></svg-icon>
													已投递
												</span>
											</div>
										</div>
										<div class="position-meta">
											<span class="position-salary">{{ item.salary }}</span>
											<span class="position-location">{{ item.location }}</span>
											<span class="position-education">{{ item.education }}</span>
											<span class="position-experience">{{ item.experience }}</span>
										</div>
									</div>
									<!-- 企业信息区域 -->
									<div class="company-info">
										<div class="company-logo">
											<img src="@/assets/employment/companyLogo.png" alt="公司logo" />
										</div>
										<div class="company-detail">
											<div class="company-name">{{ item.companyName }}</div>
											<div class="company-meta">
												<span>{{ item.companySize }}</span>
												<span>{{ item.companyType }}</span>
												<span>{{ item.companyIndustry }}</span>
											</div>
										</div>
									</div>
								</div>

								<!-- 分页器 -->
								<jr-pagination
									:limit="pageOptions.limit"
									:page.sync="pageOptions.page"
									:total="pageOptions.total"
									layout="prev, pager, next"
									prev-text="上一页"
									next-text="下一页"
									@change="handlePaginationChange"
								></jr-pagination>
							</div>
							<!-- 右侧广告区域 -->
							<div class="position-sidebar">
								<div class="hot-recruitment">
									<!-- 顶部图片 -->
									<div class="hot-recruitment-header">
										<img src="@/assets/employment/hot-recruitment.jpg" alt="火热招聘" />
									</div>

									<!-- 企业列表 -->
									<div class="hot-recruitment-list">
										<div v-for="(company, index) in hotCompanies" :key="index" class="hot-company-item">
											<!-- 企业信息头部 -->
											<div class="hot-company-header" :class="{ active: company.isExpanded }" @click="toggleCompanyExpand(index)">
												<div class="hot-company-tag">TOP {{ index + 1 }}</div>
												<div class="hot-company-info">
													<div class="hot-company-logo">
														<img src="@/assets/employment/companyLogo_01.jpg" alt="公司logo" />
													</div>
													<div class="hot-company-detail">
														<div class="hot-company-name">{{ company.name }}</div>
														<div class="hot-company-meta">{{ company.industry }} · {{ company.type }} · {{ company.size }}</div>
													</div>
												</div>
											</div>

											<!-- 企业岗位列表 -->
											<div v-show="company.isExpanded" class="hot-company-positions" :class="{ expanded: company.isExpanded }">
												<div
													v-for="(position, posIndex) in company.positions"
													:key="posIndex"
													class="hot-position-item"
													@click="handleNavigationDeatil"
												>
													<div class="hot-position-header">
														<div class="hot-position-title">{{ position.title }}</div>
														<div class="hot-position-salary">{{ position.salary }}</div>
													</div>
													<div class="hot-position-meta">
														<span class="hot-position-location">{{ position.location }}</span>
														<span class="hot-position-education">{{ position.education }}</span>
														<span class="hot-position-experience">{{ position.experience }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="poster-container">
									<img src="@/assets/poster/poster-hire_01.jpg" alt="招聘无忧" />
								</div>
							</div>
						</div>
					</div>
					<!-- 岗位内容区域--end -->
					<!-- 人才内容区域--start -->
					<div :class="['tab-pane-content__item', { active: activeTab === 1 }]">
						<!-- 搜索区域--start -->
						<div class="position-search-container">
							<!-- 搜索框区域 -->
							<div class="search-header">
								<div class="search-input-box">
									<el-select v-model="cityValue" placeholder="武汉" size="small" class="city-select">
										<el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
									<el-select v-model="certTypeValue" placeholder="PMC注册安全工程师" size="small" class="cert-type-select">
										<el-option
											v-for="item in certTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
									<el-input v-model="searchKeyword" placeholder="搜索证书号等" size="small" class="search-input"></el-input>
									<button class="cjt-button cjt-button--primary search-btn" type="button">高级查询</button>
								</div>
							</div>

							<!-- 过滤条件--start -->
							<div class="filter-group-container">
								<!-- 经验要求 -->
								<div class="filter-group">
									<div class="filter-label">经验要求：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in experienceOptions"
											:key="'exp-' + index"
											:class="['filter-option', { active: experienceValue === item.value }]"
											@click="experienceValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>
								<!-- 学历要求 -->
								<div class="filter-group">
									<div class="filter-label">学历要求：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in educationOptions"
											:key="'edu-' + index"
											:class="['filter-option', { active: educationValue === item.value }]"
											@click="educationValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>
								<!-- 薪资待遇 -->
								<div class="filter-group">
									<div class="filter-label">薪资待遇：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in salaryOptions"
											:key="'sal-' + index"
											:class="['filter-option', { active: salaryValue === item.value }]"
											@click="salaryValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>

								<!-- 求职意向 -->
								<div class="filter-group">
									<div class="filter-label">求职意向：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in intentionOptions"
											:key="'int-' + index"
											:class="['filter-option', { active: intentionValue === item.value }]"
											@click="intentionValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>

								<!-- 资质类型 -->
								<div class="filter-group">
									<div class="filter-label">资质类型：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in qualificationOptions"
											:key="'qua-' + index"
											:class="['filter-option', { active: qualificationValue === item.value }]"
											@click="qualificationValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>

								<!-- 性别 -->
								<div class="filter-group">
									<div class="filter-label">性别：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in genderOptions"
											:key="'gen-' + index"
											:class="['filter-option', { active: genderValue === item.value }]"
											@click="genderValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>

								<!-- 证书数量 -->
								<div class="filter-group">
									<div class="filter-label">证书数量：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in certCountOptions"
											:key="'cert-' + index"
											:class="['filter-option', { active: certCountValue === item.value }]"
											@click="certCountValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>
							</div>
							<!-- 过滤条件--end -->
						</div>
						<!-- 搜索区域--end -->

						<!-- 求职人才信息--start -->
						<div class="talent-card-container">
							<!-- 总数量 -->
							<div class="talent-count">共{{ 18 }}人</div>
							<!-- 人才信息-->
							<div class="talent-card-box">
								<div class="talent-card" v-for="(i, k) in 18" :key="k" @click="handleToRecommend">
									<img src="~@/assets/index/index-zw2.png" alt="" />
									<div class="talent-card-item">
										<div class="talent-header">
											<div class="talent-title">PMC注册安全工程师</div>
											<div class="salary">15K～20K/月</div>
										</div>
										<div class="talent-details">
											<div class="age">25岁</div>
											<div class="education">本科</div>
											<div class="experience">3年</div>
											<div class="job-status">离职随时到岗</div>
										</div>
										<div class="company-info">
											<div class="company-name">
												<span>求职期望：</span>
												PMC注册安全工程师
											</div>
										</div>
										<div class="company-info">
											<div class="company-size">
												<span>专业证书：</span>
												建筑电工、建筑架子工
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 人才内容区域--end -->
					<!-- 企业内容区域--start -->
					<div :class="['tab-pane-content__item', { active: activeTab === 2 }]">
						<!-- 搜索区域--start -->
						<div class="position-search-container">
							<!-- 搜索框区域 -->
							<div class="search-header">
								<div class="search-input-box">
									<el-select v-model="cityValue" placeholder="武汉" size="small" class="city-select">
										<el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
									<el-select v-model="certTypeValue" placeholder="PMC注册安全工程师" size="small" class="cert-type-select">
										<el-option
											v-for="item in certTypeOptions"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
									<el-input v-model="searchKeyword" placeholder="搜索证书号等" size="small" class="search-input"></el-input>
									<button class="cjt-button cjt-button--primary search-btn" type="button">高级查询</button>
								</div>
							</div>

							<!-- 过滤条件--start -->
							<div class="filter-group-container">
								<!-- 公司性质 -->
								<div class="filter-group">
									<div class="filter-label">公司性质：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in companyTypeOptions"
											:key="'type-' + index"
											:class="['filter-option', { active: companyTypeValue === item.value }]"
											@click="companyTypeValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>

								<!-- 公司规模 -->
								<div class="filter-group">
									<div class="filter-label">公司规模：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in companySizeOptions"
											:key="'size-' + index"
											:class="['filter-option', { active: companySizeValue === item.value }]"
											@click="companySizeValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>

								<!-- 公司行业 -->
								<div class="filter-group">
									<div class="filter-label">公司行业：</div>
									<div class="filter-options">
										<span
											v-for="(item, index) in companyIndustryOptions"
											:key="'industry-' + index"
											:class="['filter-option', { active: companyIndustryValue === item.value }]"
											@click="companyIndustryValue = item.value"
										>
											{{ item.label }}
										</span>
									</div>
								</div>
							</div>
							<!-- 过滤条件--end -->
						</div>
						<!-- 搜索区域--end -->
						<!-- 企业信息--start -->
						<div class="enterprise-card-container">
							<!-- 总数量 -->
							<div class="enterprise-count">共{{ 9 }}家</div>
							<!-- 企业信息-->
							<div class="enterprise-card-box">
								<div class="enterprise-card" v-for="i in 9" :key="i">
									<!-- 公司信息 -->
									<div class="company-info">
										<img src="@/assets/employment/enterprise-logo.png" alt="公司logo" class="company-logo" />
										<div class="company-info-right">
											<span class="company-name">中安华力建设集团有限公司</span>
											<span class="company-details">100-499人 | 国有企业 | 房地产开发商</span>
										</div>
									</div>

									<div class="enterprise-card-content">
										<div class="enterprise-card-item" v-for="i in 3" :key="i">
											<!-- 职位信息 -->
											<div class="enterprise-info">
												<div class="enterprise-title">PMC注册安全工程师</div>
												<div class="salary">15K～20K/月</div>
											</div>

											<!-- 职位详情 -->
											<div class="enterprise-details">
												<div class="location">武汉-洪山区</div>
												<div class="education">本科</div>
												<div class="experience">3～5年</div>
											</div>
										</div>
									</div>

									<!-- 查看更多职位 -->
									<div class="view-more">
										<el-button type="text" @click="handleViewMore">
											{{ showMoreFields ? '收起' : '查看更多职位' }}
										</el-button>
										<i :class="showMoreFields ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 企业内容区域--end -->
				</div>
				<!-- tab内容区域--end -->
			</div>
		</div>
	</div>
</template>

<script>
	import JrPagination from '@/components/Pagination'

	// 求职招聘专区
	export default {
		name: 'RecruitmentCenter',
		components: {
			JrPagination
		},
		props: {},
		data() {
			return {
				// 当前激活的选项
				activeTab: 0,
				// tab选项
				recruitmentTabs: [
					{
						name: '岗位'
					},
					{
						name: '人才'
					},
					{
						name: '企业'
					}
				],

				// 搜索相关数据
				searchKeyword: '',
				cityValue: '武汉',
				cityOptions: [
					{ value: '武汉', label: '武汉' },
					{ value: '黄石', label: '黄石' },
					{ value: '十堰', label: '十堰' },
					{ value: '宜昌', label: '宜昌' }
				],
				certTypeValue: 'PMC注册安全工程师',
				certTypeOptions: [
					{ value: 'PMC注册安全工程师', label: 'PMC注册安全工程师' },
					{ value: '建造师', label: '建造师' },
					{ value: '造价工程师', label: '造价工程师' }
				],
				// 筛选条件相关数据
				resourceTypeValue: '',
				resourceTypeOptions: [
					{ value: '107', label: '建筑业企业资质' },
					{ value: '112', label: '房地产估价机构备案' },
					{ value: '106', label: '工程监理企业资质' }
				],

				// 岗位列表数据
				positionList: [
					{
						title: 'PMC注册安全工程师',
						isCollected: true,
						isDelivered: true,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: true,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: true,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					}
				],
				pageOptions: {
					currentPage: 1,
					limit: 10,
					total: 100
				},
				// 热门企业数据
				hotCompanies: [
					{
						name: '惠盟电力',
						industry: '新能源',
						type: '电力/热力',
						size: '50-99人',
						isExpanded: true, // 默认展开第一个
						positions: [
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							}
						]
					},
					{
						name: '惠盟电力',
						industry: '新能源',
						type: '电力/热力',
						size: '50-99人',
						isExpanded: false, // 默认展开第一个
						positions: [
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							}
						]
					},
					{
						name: '惠盟电力',
						industry: '新能源',
						type: '电力/热力',
						size: '50-99人',
						isExpanded: false, // 默认展开第一个
						positions: [
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							},
							{
								title: 'PMC注册安全工程师',
								salary: '15K~20K/月',
								location: '武汉·洪山区',
								education: '本科',
								experience: '3~5年'
							}
						]
					}
				],

				// 筛选条件相关数据
				// 经验要求
				experienceValue: '',
				experienceOptions: [
					{ value: '', label: '不限' },
					{ value: '0-1', label: '1年以内' },
					{ value: '1-3', label: '1-3年' },
					{ value: '3-5', label: '3-5年' },
					{ value: '5-10', label: '5-10年' },
					{ value: '10+', label: '10年以上' }
				],

				// 学历要求
				educationValue: '',
				educationOptions: [
					{ value: '', label: '不限' },
					{ value: '1', label: '初中及以下' },
					{ value: '2', label: '中专/中技' },
					{ value: '3', label: '高中' },
					{ value: '4', label: '大专' },
					{ value: '5', label: '本科' },
					{ value: '6', label: '硕士' },
					{ value: '7', label: '博士' }
				],

				// 薪资待遇
				salaryValue: '',
				salaryOptions: [
					{ value: '', label: '不限' },
					{ value: '0-3', label: '3k以下' },
					{ value: '3-5', label: '3-5k' },
					{ value: '5-10', label: '5-10k' },
					{ value: '10-20', label: '10-20k' },
					{ value: '50+', label: '50k以上' }
				],

				// 求职意向
				intentionValue: '',
				intentionOptions: [
					{ value: '', label: '不限' },
					{ value: '1', label: '离职-随时到岗' },
					{ value: '2', label: '在职-暂不考虑' },
					{ value: '3', label: '在职-考虑机会' },
					{ value: '4', label: '在职-月内到岗' }
				],

				// 资质类型
				qualificationValue: '',
				qualificationOptions: [
					{ value: '', label: '不限' },
					{ value: '1', label: '建筑业企业资质' },
					{ value: '2', label: '工程监理企业资质' }
				],

				// 性别
				genderValue: '',
				genderOptions: [
					{ value: '', label: '不限' },
					{ value: 'male', label: '男' },
					{ value: 'female', label: '女' }
				],

				// 证书数量
				certCountValue: '',
				certCountOptions: [
					{ value: '', label: '不限' },
					{ value: '0-3', label: '3以下' },
					{ value: '3-5', label: '3-5' },
					{ value: '5+', label: '5以上' }
				],

				// 公司性质
				companyTypeValue: '',
				companyTypeOptions: [
					{ value: '', label: '不限' },
					{ value: 'state', label: '国企' },
					{ value: 'private', label: '私企' }
				],

				// 公司规模
				companySizeValue: '',
				companySizeOptions: [
					{ value: '', label: '不限' },
					{ value: '0-20', label: '0-20人' },
					{ value: '20-99', label: '20-99人' },
					{ value: '100-499', label: '100-499人' },
					{ value: '500-999', label: '500-999人' },
					{ value: '1000+', label: '1000人以上' }
				],

				// 公司行业
				companyIndustryValue: '',
				companyIndustryOptions: [
					{ value: '', label: '不限' },
					{ value: 'security', label: '信息安全' },
					{ value: 'internet', label: '互联网' },
					{ value: 'software', label: '计算机软件' }
				],
				// 控制更多字段的显示状态
				showMoreFields: false
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 分页
			handlePaginationChange(pager) {
				// const { page, limit } = pager
			},

			// 切换企业展开状态
			toggleCompanyExpand(index) {
				this.hotCompanies.forEach((company, i) => {
					if (i === index) {
						company.isExpanded = !company.isExpanded
					} else {
						company.isExpanded = false
					}
				})
			},

			handleNavigationDeatil() {
				this.$router.push({
					path: '/employment/job-detail'
				})
			},

			// 人才详情跳转
			handleToRecommend() {
				this.$router.push({
					path: '/employment/recommend'
				})
			},

			//查看更多
			handleViewMore() {
				console.log('查看更多')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/styles/employment.scss';

	.recruitment-center {
		background-color: #eff6f9;
		padding: 20px 0;
		.recruitment-box {
			width: $main-page-width;
			margin: 0 auto;
			padding: 20px;
			background-color: #ffffff;
			box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
			border-radius: 6px;
		}

		// 岗位搜索区域样式
		.position-search-container {
			padding: 20px;
			background-color: #f1f7ff;
			// 搜索输入框
			.search-header {
				margin-bottom: 20px;

				.search-input-box {
					display: flex;
					align-items: center;

					.city-select {
						width: 100px;
						margin-right: 10px;
					}

					.cert-type-select {
						width: 220px;
						height: 60px;
						line-height: 60px;
						margin-right: 10px;
					}

					.search-input {
						flex: 1;
						height: 60px;
						line-height: 60px;
						margin-right: 10px;
					}

					.city-select,
					.cert-type-select,
					.search-input {
						background-color: #ffffff;
						box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
						border-radius: 4px;

						::v-deep .el-input__inner {
							height: 60px;
							line-height: 60px;
							font-size: 18px;
							color: #999999;
							border: none;
						}
					}

					.search-btn {
						height: 60px;
						background-color: #236fca;
						border-color: #236fca;
						box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
						border-radius: 4px;
					}
				}
			}

			.filter-container {
				display: flex;
				align-items: center;

				.filter-item {
					width: 130px;
					margin-right: 20px;
					box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
				}

				.filter-select {
					width: 100%;
					::v-deep .el-input__inner {
						height: 40px;
						line-height: 40px;
						font-size: 18px;
						color: #999999;
						border: none;
					}
				}

				.filter-empty {
					margin-left: auto;
				}
			}
		}

		// 人才信息、企业信息
		.talent-card-container,
		.enterprise-card-container {
			padding-top: 20px;
			.talent-count,
			.enterprise-count {
				// 增加底部外边距，让与下方内容间距更明显
				margin-bottom: 20px;
				// 设置字体颜色，使用更醒目的蓝色
				color: #1e94f8;
				// 增大字体大小
				font-size: 18px;
				// 加粗字体
				font-weight: bold;
				// 添加左内边距，让文字与左侧有一定间距
				padding-left: 10px;
				// 添加左侧边框，增强视觉冲击力
				border-left: 3px solid #1e94f8;
			}
		}

		// 热门岗位
		.position-content {
			display: flex;
			margin-top: 20px;

			// 右侧广告区域
			.position-sidebar {
				width: 440px;

				.hot-recruitment {
					border: 1px solid #bdd4ef;
					border-radius: 8px;
					overflow: hidden;
					background-color: #f1f7ff;

					// 顶部图片
					.hot-recruitment-header {
						width: 100%;
						height: 145px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}

					// 企业列表
					.hot-recruitment-list {
						padding: 20px;
						.hot-company-item {
							border: solid 1px #e2e6ea;
							margin-bottom: 20px;

							&:last-child {
								margin-bottom: 0;
							}

							// 企业信息头部
							.hot-company-header {
								padding: 15px;
								background-image: url('~@/assets/employment/hot-recruitment-header.jpg');
								background-repeat: no-repeat;
								background-position: center;
								cursor: pointer;
								position: relative;
								transition: all 0.3s;

								&.active {
								}

								.hot-company-tag {
									position: absolute;
									top: 0;
									right: 0;
									color: #236fca;
									padding: 2px 15px;
									font-size: 12px;
									border-radius: 0 0 0 10px;
									background-color: #ffffff;
									opacity: 0.7;
								}

								.hot-company-info {
									display: flex;
									align-items: center;

									.hot-company-logo {
										width: 50px;
										height: 50px;
										margin-right: 10px;
										background-color: #ffffff;
										border-radius: 4px;
										overflow: hidden;

										img {
											width: 100%;
											height: 100%;
											object-fit: contain;
										}
									}

									.hot-company-detail {
										.hot-company-name {
											font-size: 16px;
											color: #ffffff;
											font-weight: bold;
											margin-bottom: 5px;
										}

										.hot-company-meta {
											font-size: 14px;
											color: #ffffff;
										}
									}
								}
							}

							// 企业岗位列表
							.hot-company-positions {
								background-color: #ffffff;
								// 过渡动画
								transition: all 0.3s ease-in-out;
								max-height: 0;
								overflow: hidden;
								opacity: 0;

								&.expanded {
									max-height: 500px; // 设置一个足够大的高度
									opacity: 1;
								}

								.hot-position-item {
									padding: 15px 0;
									margin: 0 20px;
									border-bottom: 1px dashed #e0e9f5;
									cursor: pointer;

									&:last-child {
										border-bottom: none;
									}

									&:hover {
										background-color: #f1f7ff;
									}

									.hot-position-header {
										display: flex;
										justify-content: space-between;
										align-items: center;
										margin-bottom: 10px;

										.hot-position-title {
											flex: 1;
											margin-right: 10px;
											font-size: 16px;
											font-weight: bold;
											color: #333333;
										}

										.hot-position-salary {
											min-width: 90px;
											color: #ff5013;
											font-size: 16px;
										}
									}

									.hot-position-meta {
										display: flex;
										flex-wrap: wrap;

										span {
											margin-right: 10px;
											margin-bottom: 5px;
											font-size: 14px;

											&.hot-position-location,
											&.hot-position-education,
											&.hot-position-experience {
												color: #1e94f8;
												background-color: #daeaff;
												padding: 2px 8px;
												border-radius: 4px;
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}

		.filter-group-container {
			display: flex;
			flex-direction: column;
			margin-bottom: 15px;

			.filter-group {
				display: flex;
				margin-bottom: 15px;

				.filter-label {
					width: 90px;
					font-size: 16px;
					color: #333;
					line-height: 32px;
					font-weight: bold;
				}

				.filter-options {
					flex: 1;
					display: flex;
					flex-wrap: wrap;

					.filter-option {
						padding: 0 15px;
						height: 32px;
						line-height: 32px;
						background: #daeaff;
						border-radius: 4px;
						margin-right: 10px;
						margin-bottom: 10px;
						font-size: 16px;
						color: #666;
						cursor: pointer;
						transition: all 0.3s;

						&:hover {
							color: #1e94f8;
							background-color: #daeaff;
						}

						&.active {
							background-color: #1e94f8;
							color: #ffffff;
						}
					}
				}
			}

			.filter-empty {
				align-self: flex-end;
				color: #236fca;
				font-size: 14px;
				text-decoration: none;
				margin-top: 10px;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}

	::v-deep .el-select-dropdown__item {
		font-size: 16px;
	}
</style>
